import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useCurrentUser from 'infrastructure/currentUser/useCurrentUser';
import useCards from './useCards';

/**
 * Hook for restricting access for Cards routes
 */
const useCardsRoutingGuard = () => {
  const history = useHistory();
  const cardsFeatureFlag = useCards();
  const { hasAnalyticsViewerPermissions } = useCurrentUser();

  useEffect(() => {
    // Keep the guard mounted for route compatibility while Cards is always on.
    // Avoid redirecting while feature flags are still loading (e.g. during HMR)
    if (cardsFeatureFlag === undefined) {
      return;
    }

    if (cardsFeatureFlag === true) {
      return;
    }

    history.push(hasAnalyticsViewerPermissions ? '/analytics' : '/stories');
  }, [cardsFeatureFlag, hasAnalyticsViewerPermissions, history]);
};

export default useCardsRoutingGuard;
